import { useSelector } from 'react-redux';

import { ReactComponent as SuccessRequest } from 'assets/img/icons/successRequest.svg';
import { ReactComponent as WeReachShortly } from 'assets/img/icons/weReachShortly.svg';
import { ReactComponent as UploadSuccessIcon } from 'assets/img/icons/uploadSuccess.svg';

import { Button, Col, Modal, Row } from 'antd';
import LoadingSpinner from './LoadingSpinner';
import { useTranslation } from 'react-i18next';

const SuccessModal = ({
  type = '',
  title = 'common.success',
  text = null,
  isOpen,
  setIsOpen = () => {},
  closable = true,
  size = 'md',
  className = '',
  secondaryTitle,
  onCancel,
  isLoading = false,
  debtManagement = false,
  ...rest
}) => {
  const { t } = useTranslation();
  const {} = useSelector(state => state.administration);

  const icon =
    type === 'notifyIncorrectDebt' ? (
      <WeReachShortly />
    ) : type === 'uploadDebts' || type === 'expertValue' ? (
      <UploadSuccessIcon />
    ) : (
      <SuccessRequest />
    );
  return (
    <Modal
      className={`success-modal ${className}`}
      visible={isOpen}
      footer={null}
      closable={closable}
      maskClosable={closable}
      onCancel={onCancel}
      width={size === 'md' ? 470 : 650}
      confirmLoading={true}
      {...rest}
    >
      <LoadingSpinner size="small" spinning={isLoading}>
        <Row gutter={16}>
          <Col span={4} className="icon justify-content-center align-items-center">
            {icon}
          </Col>
          <Col span={20} className="content">
            <Row>
              <Col className="align-items-end title" span={24}>
                {t(`success.${type ? type : 'common'}.title`)}
              </Col>
              <Col align="start" justify="center" className="text" span={24}>
                {debtManagement && (type === 'notifyIncorrectDebt' || type === 'uploadDebts')
                  ? t(`success.${type ? type : 'common'}.text`)
                  : text}
              </Col>
            </Row>
          </Col>
          <Button
            className="btn-success"
            style={{ position: 'absolute', bottom: -10, right: 0 }}
            size="small"
            onClick={onCancel}
          >
            {t('common.okay')}
          </Button>
        </Row>
      </LoadingSpinner>
    </Modal>
  );
};

export default SuccessModal;
